import { ContasReceberListaFilter } from "../../../domain/models/contas_receber_lista_filter";
import { IGetAllContasReceberListaUseCase } from "../../../presentation/useCases/read/get_all_contas_receber_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";
import { BasePaginatedUseCase } from '../../../../../common/domain/useCases/base_paginated_use_case';
import { ContasReceberLista } from '../../models/contas_receber_lista';
import { ValoresContasMes } from "../../../../comercial/domain/models/valores_contas_mes";

/**
 * GetAllContasReceberListaUseCase
 */

export class GetAllContasReceberListaUseCase extends BasePaginatedUseCase<ContasReceberLista> implements IGetAllContasReceberListaUseCase {
  constructor(private readonly repository: IFinanceiroRepository) {
    super();
  }

  async getAllContasReceberLista(
    filter: ContasReceberListaFilter,
    page: number,
    rowsPerPage: number): Promise<ValoresContasMes> {
    const result = await this.repository.getAllContasReceberLista(filter, page, rowsPerPage);

    this._items = result.lista.items;
    this._currentPage = result.lista.currentPage;
    this._pageSize = result.lista.pageSize;
    this._totalItems = result.lista.totalItems;
    this._totalPages = result.lista.totalPages;

    return result.indicadores;
  }


}
